import React from 'react';
import { DBGWithType } from '~modules/devices/components/DeviceHealthTable/types';

export const useDeviceDetail = (devices: DBGWithType[]) => {
  const [selectedDevices, setSelectedDevices] = React.useState<DBGWithType[]>();
  const [selectedDeviceDetail, setSelectedDeviceDetail] = React.useState<DBGWithType>();
  const [isEditingDevice, setIsEditingDevice] = React.useState(false);

  React.useEffect(() => {
    const first = selectedDevices?.[0];
    if (!first) {
      setSelectedDeviceDetail(undefined);
      return;
    }
    const device = devices.find((x) => x.type === first.type && x.id === first.id) ?? first;
    setSelectedDeviceDetail(device);
  }, [selectedDevices, devices]);

  const handleCloseDetail = React.useCallback(() => {
    setSelectedDevices(undefined);
    setSelectedDeviceDetail(undefined);
    setIsEditingDevice(false);
  }, []);

  return {
    selectedDevices,
    setSelectedDevices,
    selectedDeviceDetail,
    isEditingDevice,
    setIsEditingDevice,
    handleCloseDetail,
  };
};
